import _ from 'lodash';
import { types } from 'generic/core/search/actions';

const searchReducer = (state = {
  results: {},
  loading: false,
  isRAGSearch: false,
  loadingBlank: false,
  quickResults: {},
  quickLoading: false,
  quickLoadingBlank: false,
  resultsComplete: {},
  openedCompleteId: null,
  loadingComplete: false,
  fetchError: null,
}, action) => {
  switch (action.type) {
    case types.CLEANUP_RESULTS: {
      return {
        ...state,
        results: {},
        fetchError: null,
      };
    }
    case types.CLEANUP_QUICK_RESULTS: {
      return {
        ...state,
        quickResults: {},
      };
    }
    case types.FETCH_RESULTS: {
      let fetchStateItems = {
        loading: true,
        loadingBlank: action.values.clearResults,
        results: action.values.clearResults ? {} : { ...state.results },
      };
      if (action.values.quickResultsScope) {
        fetchStateItems = {
          quickLoading: true,
          quickLoadingBlank: action.values.clearQuickResults,
          quickResults: action.values.clearQuickResults ? {} : { ...state.quickResults },
        };
      }
      return {
        ...state,
        ...fetchStateItems,
        fetchError: null,
        isRAGSearch: !!action.values.isRAGSearch,
      };
    }
    case types.FETCH_RESULTS_SUCCESS: {
      const { facets: resultsFacets } = action.results;
      const facets = _.map(
        resultsFacets,
        (facet) => ({
          ...facet,
          mouvement: null,
          mouvement_maitre: null,
          facetValues: _.map(
            facet.facetValues,
            ({
              champ,
              formatFacet,
              frequence,
              id,
              libelle,
              strategie,
            }) => ({
              champ,
              formatFacet,
              frequence,
              id,
              libelle,
              strategie,
            }),
          ),
        }),
      );
      return {
        ...state,
        results: {
          ...action.results,
          facets,
        },
        loading: false,
        loadingBlank: false,
        fetchError: null,
      };
    }
    case types.FETCH_QUICK_RESULTS_SUCCESS: {
      return {
        ...state,
        quickResults: {
          ...action.results,
        },
        quickLoading: false,
        quickLoadingBlank: false,
      };
    }
    case types.FETCH_RESULTS_ERROR: {
      return {
        ...state,
        results: {},
        loading: false,
        loadingBlank: false,
        fetchError: action.response.status,
      };
    }
    case types.CLEANUP_RESULTS_COMPLETE: {
      return {
        ...state,
        loadingComplete: false,
        openedCompleteId: null,
        resultsComplete: {},
      };
    }
    case types.FETCH_RESULTS_COMPLETE: {
      return {
        ...state,
        loadingComplete: true,
        openedCompleteId: action.id,
        resultsComplete: {},
      };
    }
    case types.FETCH_RESULTS_COMPLETE_SUCCESS: {
      return {
        ...state,
        resultsComplete: {
          ...action.results,
        },
        loadingComplete: false,
      };
    }
    case types.FETCH_RESULTS_COMPLETE_ERROR: {
      return {
        ...state,
        resultsComplete: {},
        loadingComplete: false,
      };
    }
    case types.PATCH_RESULTS_COMPLETE: {
      const resultsCompleteCloned = _.cloneDeep(state.resultsComplete);
      if (!_.isEmpty(resultsCompleteCloned) && resultsCompleteCloned.documents[0].idext === action.id) {
        resultsCompleteCloned.documents[0] = {
          ...resultsCompleteCloned.documents[0],
          qesdocument: {
            ...resultsCompleteCloned.documents[0].qesdocument,
            ...action.patchedFields,
          },
        };
      }
      return {
        ...state,
        resultsComplete: resultsCompleteCloned,
      };
    }
    case types.UPDATE_DOCUMENT_COMMENTS: {
      const resultsCloned = _.cloneDeep(state.results);
      const docToUpdate = _.find(resultsCloned.documents, { idext: action.idext });
      if (!_.isEmpty(docToUpdate)) {
        docToUpdate.commentaires = action.comments;
        docToUpdate.hasComment = _.some(action.comments, { user_id: action.userId });
        docToUpdate.commentAlert = _.some(action.comments, { user_id: action.userId, alert: true });
      }
      const quickResultsCloned = _.cloneDeep(state.quickResults);
      const quickDocToUpdate = _.find(quickResultsCloned.documents, { idext: action.idext });
      if (!_.isEmpty(quickDocToUpdate)) {
        quickDocToUpdate.commentaires = action.comments;
        quickDocToUpdate.hasComment = _.some(action.comments, { user_id: action.userId });
        quickDocToUpdate.commentAlert = _.some(action.comments, { user_id: action.userId, alert: true });
      }
      const resultsCompleteCloned = !_.isEmpty(state.resultsComplete) ? _.cloneDeep(state.resultsComplete) : {};
      const docCompleteToUpdate = _.find(resultsCompleteCloned.documents, { idext: action.idext });
      if (!_.isEmpty(docCompleteToUpdate)) {
        docCompleteToUpdate.commentaires = action.comments;
        docCompleteToUpdate.hasComment = _.some(action.comments, { user_id: action.userId });
        docCompleteToUpdate.commentAlert = _.some(action.comments, { user_id: action.userId, alert: true });
      }
      return {
        ...state,
        results: resultsCloned,
        quickResults: quickResultsCloned,
        resultsComplete: resultsCompleteCloned,
        loading: false,
      };
    }
    case types.UPDATE_DOCUMENT_ALERT: {
      const resultsCloned = _.cloneDeep(state.results);
      const docToUpdate = _.find(resultsCloned.documents, { idext: action.idext });
      if (!_.isEmpty(docToUpdate)) {
        docToUpdate.commentAlert = action.alert;
      }
      const quickResultsCloned = _.cloneDeep(state.quickResults);
      const quickDocToUpdate = _.find(quickResultsCloned.documents, { idext: action.idext });
      if (!_.isEmpty(quickDocToUpdate)) {
        quickDocToUpdate.commentAlert = action.alert;
      }
      const resultsCompleteCloned = !_.isEmpty(state.resultsComplete) ? _.cloneDeep(state.resultsComplete) : {};
      const docCompleteToUpdate = _.find(resultsCompleteCloned.documents, { idext: action.idext });
      if (!_.isEmpty(docCompleteToUpdate)) {
        docCompleteToUpdate.commentAlert = action.alert;
      }
      return {
        ...state,
        results: resultsCloned,
        quickResults: quickResultsCloned,
        resultsComplete: resultsCompleteCloned,
      };
    }
    case types.SET_DOCUMENT_MORE_LIKE_THIS_LOADING: {
      const resultsCloned = _.cloneDeep(state[action.reduxDocumentsKey]);
      const docToUpdate = _.find(resultsCloned.documents, { idext: action.idext });
      if (!_.isEmpty(docToUpdate)) {
        docToUpdate.loadingMoreLikeThis = action.loadingMoreLikeThis;
      }
      return {
        ...state,
        [action.reduxDocumentsKey]: resultsCloned,
      };
    }
    case types.UPDATE_DOCUMENT_MORE_LIKE_THIS: {
      const resultsCloned = _.cloneDeep(state[action.reduxDocumentsKey]);
      const docToUpdate = _.find(resultsCloned.documents, { idext: action.idext });
      if (!_.isEmpty(docToUpdate)) {
        docToUpdate.morelikethis = action.morelikethis;
      }
      return {
        ...state,
        [action.reduxDocumentsKey]: resultsCloned,
      };
    }
    default:
      return state;
  }
};

export default searchReducer;
